module.exports = __webpack_public_path__ + "img/6.f6f43f5c.png";